module.exports = __webpack_public_path__ + "static/media/cc-waiting-spanish.94991e83.vtt";